<template>
  <div class="overflow-y-scroll h-full min-h-full pb-32">
    <div
      v-if="subView === 'Default'"
      class="flex-1 relative pb-8 z-0"
    >
      <div class="bg-white shadow">
        <div class="px-4 sm:px-6 lg:mx-auto lg:px-8 max-w-7xl">
          <div class="pt-6 pb-6 md:flex md:items-center justify-between lg:border-t lg:border-cool-gray-200">
            <div class="text-3xl font-bold leading-7 text-cool-gray-900 sm:leading-9 sm:truncate">
              Players
            </div>

            <PrimaryButton
              text="New player"
              icon="fal fa-plus"
              @click="subView = 'NewContact'"
            />
          </div>

          <div class="pb-4">
            <Tabs
              :tabs="tabs"
              :selected-tab="selectedTab"
              @select="setTab"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="subView === 'Default'"
      class="pt-8 pb-32 px-8 max-w-7xl ml-auto mr-auto"
    >
      <!-- <Table
        type="ContactDetail"
      /> -->

      <div v-if="players.length > 0">
        <div class="flex flex-col">
          <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div class="shadow overflow-hidden border-gray-300 sm:rounded-lg border">
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Address
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Phone Number
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Type
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="player in players">
                      <td class="px-6 py-4 whitespace-nowrap">
                        <div class="flex items-center">
                          <div class="flex-shrink-0 h-10 w-10">
                            <div class="w-10 h-10 bg-gray-800 uppercase rounded-full flex justify-center items-center text-white leading-none text-center select-none">
                              {{ player.name.split(" ")[0].charAt(0) }}<span v-if="player.name.split(' ')[1] !== undefined">{{ player.name.split(" ")[1].charAt(0) }}</span>
                            </div>
                          </div>
                          <div class="ml-4">
                            <div class="text-sm font-medium text-gray-900">
                              {{ player.name }}
                            </div>
                            <div class="text-sm text-gray-500">
                              {{ player.emailAddress }}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <div v-if="(player.address1 !== null || player.address2 !== null) && (player.address1 !== '' || player.address2 !== '')">
                          <div class="text-sm text-gray-900">
                            {{ player.address1 }}
                          </div>
                          <div class="text-sm text-gray-500">
                            {{ player.address2 }}
                          </div>
                        </div>
                        <div
                          v-else
                          class="text-sm text-gray-400"
                        >
                          -
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <div
                          v-if="player.telephoneNumber !== null && player.telephoneNumber !== ''"
                          class="text-sm text-gray-500"
                        >
                          {{ player.telephoneNumber }}
                        </div>
                        <div
                          v-else
                          class="text-sm text-gray-400"
                        >
                          -
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        <div class="flex items-center">
                          <div
                            class="rounded-full text-xs w-5 h-5 mr-2 leading-none select-none flex items-center justify-center text-white bg-gradient-to-t shadow border cursor-default"
                            :class="getTypeBackground(player.type)"
                            style="padding-left: 1px;"
                          >
                            {{ getTypeChar(player.type) }}
                          </div>
                          {{ getType(player.type) }}
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                          Active
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="flex justify-between items-center w-full min-w-full mt-4">
          <div />

          <PaginatedTabs
            :page-index="pageIndex"
            :total-pages="2"
            :visible-pages-count="7"
            @click="setIndex"
          />
        </div>
      </div>

      <div
        v-else
        class="mt-56 mb-32 ml-auto mr-auto text-center"
      >
        <LoadingSpinner />
      </div>
    </div>

    <div v-if="subView === 'NewContact'">
      <Form
        title="New player"
        secondary-action="Back"
        primary-action="Submit new player"
        primary-action-icon="fal fa-plus"
        :modal="false"
        :forms="newContactForm"
        @secondaryClick="secondaryClick"
        @success="newContactSuccess"
      />
    </div>
  </div>
</template>

<script>
import Tabs from '@/app/shared/components/navigation/tabs/tabs.vue';
import PrimaryButton from '@/app/shared/components/base/button/primaryButton.vue';
import Form from '@/app/shared/components/form/form.vue';
import Table from '@/app/shared/components/table/paginatedTable.vue';
import PaginatedTabs from '@/app/shared/components/navigation/pagination/pagination.vue';
import LoadingSpinner from '@/app/shared/components/base/loading/loadingSpinner.vue';
import { ServiceFormModel, DependantField } from '@/app/shared/components/form/classes';
import {
  GetAllPlayers, MapType, GetTypeChar, GetTypeBackground,
} from '@/app/shared/services/playerService/playerService';
import { GetContact } from '@/app/shared/services/contactService/contactService';

export default {
  name: 'Players',

  components: {
    Tabs,
    PrimaryButton,
    Form,
    Table,
    PaginatedTabs,
    LoadingSpinner,
  },

  data() {
    return {
      tabs: [
        { primaryText: 'All' },
        { primaryText: 'Members' },
        { primaryText: 'Visitors' },
      ],

      selectedTab: 'All',
      subView: 'Default',

      newContactForm: [],

      players: [],
      contacts: [],

      pageIndex: 1,
      maxCount: 10,
      totalCount: undefined,
    };
  },

  computed: {
    filteringString() {
      if (this.selectedTab === 'All') {
        return null;
      } if (this.selectedTab === 'Members') {
        return '0|1|2';
      } if (this.selectedTab === 'Visitors') {
        return '3|4|5';
      }
    },
  },

  watch: {
    selectedTab() {
      this.getPlayers();
    },
  },

  mounted() {
    this.getPlayers();
    this.initForms();
  },

  methods: {
    getPlayers() {
      this.players = [];
      GetAllPlayers(this.filteringString, true, ((this.pageIndex - 1) * this.maxCount), this.maxCount).then((data) => {
        const players = [];
        this.totalCount = data.totalCount;
        data.items.forEach((player) => {
          GetContact(player.contactDetailsId).then((contactData) => {
            players.push({ ...player, ...contactData });

            if (players.length === data.items.length) {
              this.players = players;
            }
          });
        });
      });
    },

    getTypeBackground(type) {
      return GetTypeBackground(type);
    },

    getTypeChar(type) {
      return GetTypeChar(type);
    },

    setIndex(index) {
      this.pageIndex = index;
      this.getPlayers();
    },

    getType(type) {
      return MapType(type);
    },

    secondaryClick() {
      this.subView = 'Default';
    },

    newContactSuccess() {
      this.subView = 'Default';
    },

    initForms() {
      this.newContactForm.push(
        new ServiceFormModel(
          1,
          0,
          'Contact details',
          'This will allow you to contact the player if needed and differentiate the players from others.',
          'ContactDetail',
          'Create',
          [],
          [],
        ),
        new ServiceFormModel(
          0,
          1,
          'Player details',
          'We need to know a few things about the player.',
          'Player',
          'Create',
          [new DependantField('ContactDetail', 'Create', 'id', 'contactDetailsId')],
          [],
        ),
      );
    },

    setTab(tab) {
      this.selectedTab = tab.primaryText;
    },

  },

};
</script>
